export interface ProgressBarProps {
  /** Anteil von 0 bis 1. */
  value: number;
  label: string;
  /** Text rechts, etwa "412 von 1 240". */
  caption?: string;
  tone?: 'accent' | 'success' | 'warning' | 'danger';
}

/**
 * Anteilsbalken.
 *
 * Traegt `role="progressbar"` mit den echten Werten, damit ein Screenreader
 * den Anteil vorliest statt nur "Grafik". Der Text daneben ist trotzdem
 * sichtbar: die Balkenlaenge allein laesst sich nicht ablesen.
 */
export function ProgressBar({ value, label, caption, tone = 'accent' }: ProgressBarProps) {
  const anteil = Math.min(1, Math.max(0, Number.isFinite(value) ? value : 0));
  const prozent = Math.round(anteil * 100);

  return (
    <div className="progress">
      <div className="progress__head">
        <span className="progress__label">{label}</span>
        {caption && <span className="progress__caption">{caption}</span>}
      </div>
      <div
        className="progress__track"
        role="progressbar"
        aria-label={label}
        aria-valuenow={prozent}
        aria-valuemin={0}
        aria-valuemax={100}
      >
        <span className="progress__fill" data-tone={tone} style={{ inlineSize: `${prozent}%` }} />
      </div>
    </div>
  );
}
